import { useErpProviders } from '@euler/app/flows/erp/functions/useErpProviders';
import { Icon } from '@euler/components/Icomoon';
import { TableView } from '@euler/components/TableView';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { usePersistFn } from '@euler/utils/hooks';
import { useNavigation, useRoute } from '@react-navigation/native';
import { memo, useEffect } from 'react';
import { ScrollView } from 'react-native';
import { Cell2 as Cell } from '../../settings/components/SettingsTable';

export const ErpEmployeeSelectorScreen = wrapNavigatorScreen(
  () => {
    return <Content />;
  },
  {
    title: '选择员工',
  },
);

const Content = memo(() => {
  const route = useRoute<any>();
  const navigation = useNavigation<any>();
  const {
    employees = [],
    selectedId,
    onSelect,
    providerId,
    providerName,
  } = route.params || {};
  const { getProviderName } = useErpProviders();
  const currentProviderName = getProviderName(
    providerId,
    providerName || '当前服务商',
  );

  useEffect(() => {
    navigation.setOptions({
      title: `选择${currentProviderName}员工`,
    });
  }, [currentProviderName, navigation]);

  const handleSelect = usePersistFn((id: string | null) => {
    onSelect?.(id);
    navigation.goBack();
  });

  return (
    <ScrollView css="flex: 1; background-color: #f7f7f7;">
      <TableView css="margin-top: 15px;">
        <Cell
          title="（不绑定）"
          onPress={() => handleSelect(null)}
          detailIcon={
            !selectedId ? (
              <Icon name="check" size={20} color={'#5ba0e0'} />
            ) : undefined
          }
        />
        {employees.map((emp: any) => (
          <Cell
            key={emp.id}
            title={emp.name}
            detail={emp.mobile || emp.staffno || ''}
            onPress={() => handleSelect(emp.id)}
            detailIcon={
              selectedId === emp.id ? (
                <Icon name="check" size={20} color={'#5ba0e0'} />
              ) : undefined
            }
          />
        ))}
      </TableView>
    </ScrollView>
  );
});
